import { ImgHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { isNumber } from 'chart.js/helpers';

import { badgeMileage } from '../../constants/image_url';

export const BadgeMileageImage: React.FC<React.PropsWithChildren<ImgHTMLAttributes<HTMLImageElement>>> = (props) => {
  return <Image src={badgeMileage} width={props.width ?? 16} height={17} alt='마일리지 아이콘' {...props} />;
};

const Image = styled.img<{ width?: number | string }>`
  display: inline-block;
  ${({ width }) => (width && isNumber(width) ? `width: ${width}px;` : `width: ${width}`)};
`;
